module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/left-arrow-1912088207f22bb3cba713615ac4f1d5.svg&quot;;"